import type { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

import { portalAuthQueryOptions } from "@/features/authz/hooks/use-portal-auth"

export async function requireSuperAdminRouteAccess(queryClient: QueryClient): Promise<void> {
	const auth = await queryClient.ensureQueryData(portalAuthQueryOptions)
	if (!auth.roles.includes("super_admin")) {
		throw redirect({ to: "/dashboard" })
	}
}
